import { render, staticRenderFns } from "./SettingsAccounts.vue?vue&type=template&id=be700cda&"
import script from "./SettingsAccounts.vue?vue&type=script&lang=js&"
export * from "./SettingsAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports